import { Checkbox, DatePicker } from "@ds/ds-snam/react";
import { CalendarDayServiceType, ICalendarDialogForm, ICalendarDialogFormData} from "dataModels/b2b";
import  { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from "react";
import { Col, Row, } from "react-grid-system";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { DATE_FORMAT, DsLayout, UICommand } from "shared/constants";
import { v4 as uuidv4 } from "uuid";
import { dsSelectHandler } from "shared/utils/dsComponentUtils";
import { ISelectLabel } from "@ds/ds-snam/dist/models/select";
import moment from "moment";
import { onDateInputChange } from "../shared/calendarUtils";
import { RootState } from "state/appStore";

interface SlotBookingFormProps {
    command: UICommand
}
interface IDay {
    label:string,
    id:string
}
/*const services:ISelectLabel[] = [
    { id: '0', label: 'Truck loading', selected: false },
    { id: '1', label: 'Cool down', selected: false },
    { id: '2', label: 'Gas up + Cool down', selected: false },
    { id: '3', label: 'Semi trailer approval', selected: false },
    { id: '4', label: 'Driver approval', selected: false },
    { id: '5', label: 'Semi trailer approval + Driver approval', selected: false },
    { id: '6', label: 'Iso container approval', selected: false },
    { id: '7', label: 'Iso container approval + driver approval', selected: false }
]
*/

const _days : boolean[] = [false,false,false,false,false,false,false];
const defaultFormData : ICalendarDialogFormData = {
    type:3,
    startDate:moment.utc(new Date(), DATE_FORMAT).unix(),
    endDate:moment.utc(new Date(), DATE_FORMAT).unix(),
    days:_days
}

const DeleteMultipleSlots = forwardRef<ICalendarDialogForm, SlotBookingFormProps>((props, ref) => {
    const { t, i18n } = useTranslation(["b2b", "app"]);
    const daysList:IDay[] = [
        {label:t("general.weekDays.0", {ns:['app']})/*"Lunedì"*/,id:"0"}, 
        {label:t("general.weekDays.1", {ns:['app']}),id:"1"},
        {label:t("general.weekDays.2", {ns:['app']}),id:"2"},
        {label:t("general.weekDays.3", {ns:['app']}),id:"3"},
        {label:t("general.weekDays.4", {ns:['app']}),id:"4"},
        {label:t("general.weekDays.5", {ns:['app']}),id:"5"},
        {label:t("general.weekDays.6", {ns:['app']}),id:"6"}
    ]

    const [formData, setFormData] = useState<ICalendarDialogFormData>(defaultFormData);
    const layoutMode = useSelector((state:RootState)=>{
        return state.dsLayout.mode;
    })
    
    const dispatch = useDispatch();
    const localRef = useRef<HTMLDivElement>(null);
    useImperativeHandle(ref, () => ({
        getFormValues: () => {
            return formData //qua ritornare il formdata
        }
    }));


    const checkboxChangeHandler = (day:IDay,check:boolean) => {
        let currentFormData = formData;
        currentFormData.days![Number(day.id)] = check;
        setFormData(currentFormData);
    }

    useEffect(() => {
        /*for(let i=0;i<7;i++){
            checkboxChangeHandler({id:i.toString(),label:''},false);
        }*/
        let currentFormData = {
            ...formData,
            type: 3,
            startDate: moment.utc(new Date(), DATE_FORMAT).unix(),
            endDate: moment.utc(new Date(), DATE_FORMAT).unix(),
            days: _days,
        };
        for (let i = 0; i < 7; i++) {
            currentFormData.days[i] = false;
        }
        setFormData(currentFormData);
    }, []);


    return (
        <>
            <div ref={localRef} style={{fontFamily:'Lato, Lato-local, sans-serif',color:layoutMode===DsLayout.DARK_MODE?"white":"black"}}>
                <div slot="title">
                    <h2 className="ff-ubuntu ff-title-s ff-bold" style={{ margin: "0 auto",fontFamily:'Lato, Lato-local, sans-serif',textAlign:'center' }} id="overlay-title">
                        {t('calendar.popups.deleteMultipleSlots.0')}{/*Vuoi eliminare più slot relativi ad un servizio?*/}
                    </h2>
                </div>
                <div slot="text" style={{ background:'',margin:'10px',paddingLeft:'5%',paddingRight:'5%',marginTop:'20px'}}>
                    <Row style={{ marginBottom: '40px',marginTop:'30px' }}>
                        <Col xs={12} md={6} style={{margin:'0 auto'}}>
                            <DatePicker
                                id="deleteSlotsPicker"
                                datePickerTitle={t('calendar.popups.pubblication.3')}//"Dal*/al*" //
                                isRangePicker={true}
                                startingYear={1990}
                                endingYear={2099}
                                defaultDate={new Date()}
                                disabledDates={{ lastDisabledDate: new Date() }}
                                confirmButtonLabel={t('calendar.popups.buttons.8')}//"Conferma"
                                onDateSelection={(event: Event) => {
                                    let currentData:ICalendarDialogFormData = formData;
                                    let currentFormData = onDateInputChange(event,currentData);
                                    setFormData(currentFormData)
                                }}
                            ></DatePicker>
                        </Col>
                    </Row>
                    <Row style={{marginTop:'15px'}}>
                        {daysList.map((day: IDay, index: number) => {
                            const key: string = uuidv4();
                            return (
                                <Col xs={12} md={3} key={key} style={{margin:'0 auto',marginBottom:'10px'}}>
                                    <Checkbox
                                        id={day.id}
                                        checkboxStatus="default"
                                        checkboxLabel={day.label} 
                                        isDisabled={false}
                                        isChecked={false}
                                        onCheckboxChange={(event:Event) => {
                                            checkboxChangeHandler(day,(event as CustomEvent).detail.checkbox.checked);
                                        }}
                                    />
                                </Col>
                            )
                        })}
                    </Row>
                </div>
            </div>
        </>
    );
});
export default DeleteMultipleSlots;